import React, { useState, useEffect } from 'react';
import './stylesLayoutHome.css';
import {
    MenuFoldOutlined, MenuUnfoldOutlined, ExclamationCircleOutlined, UserOutlined, LogoutOutlined, FullscreenOutlined,
    FullscreenExitOutlined
} from '@ant-design/icons';
import {
    IoAnalytics, IoClipboard, IoStorefront, IoSettings, IoCash, IoCart, IoCar, IoPricetag, IoPeople, IoCard, IoPeopleCircle,
    IoCube, IoReceipt
} from "react-icons/io5";
import { Layout, Button, theme, Modal, Dropdown, Avatar, Space, Typography, Result, Spin, Grid } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../aws/AuthContext';
import { useConfig } from '../../context/ConfigContext';
import { usePermission } from '../../hooks/usePermission';

const { Header, Sider, Content } = Layout;
const { Text } = Typography;
const { confirm } = Modal;
const { useBreakpoint } = Grid;

const LayoutHome = ({ children, pageSeleccionada }) => {

    const { logout, session } = useAuth();
    const { config, subStatus, loading: configLoading } = useConfig();
    const navigate = useNavigate();

    const { hasPermission } = usePermission();


    const screens = useBreakpoint();
    const isMobile = screens.md === false;

    const [collapsed, setCollapsed] = useState(true);

    const [isFullscreen, setIsFullscreen] = useState(false);

    const { token: { colorBgContainer } } = theme.useToken();

    const nombreEmpresa = config?.nombre || session?.empresa?.nombre || 'Mi Comercio';
    const logoEmpresa = config?.logo_url;
    const nombreUsuario = session?.user?.nombre || 'Usuario';
    const apellidosUsuario = session?.user?.apellidos || '';
    const correoUsuario = session?.user?.email || '';

    // Cerrar menú lateral en móvil
    useEffect(() => {
        if (isMobile) {
            setCollapsed(true);
        }
    }, [pageSeleccionada, isMobile]);

    // Validación de suscripción
    useEffect(() => {
        if (!configLoading && subStatus?.bloqueada && pageSeleccionada !== 'ajustes') {
            // Solo redirige automáticamente a pagos si es el administrador / tiene permisos
            if (hasPermission('configuracion:ver')) {
                navigate('/ajustes?tab=suscripcion', { replace: true });
            }
            // Si es un empleado sin permiso, NO hace nada (el render abajo lo bloquea sin redireccionar)
        }
    }, [subStatus, pageSeleccionada, navigate, configLoading, hasPermission]);

    useEffect(() => {
        const handleFullscreenChange = () => {
            setIsFullscreen(!!document.fullscreenElement);
        };

        document.addEventListener('fullscreenchange', handleFullscreenChange);
        return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
    }, []);

    const toggleFullscreen = () => {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen().catch((err) => {
                console.error(`Error al intentar entrar en pantalla completa: ${err.message}`);
            });
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            }
        }
    };

    const cerrarSesion = () => {
        confirm({
            title: <span style={{ fontSize: '18px', fontWeight: '700', color: '#1e293b' }}>¿Cerrar sesión?</span>,
            icon: <ExclamationCircleOutlined style={{ color: '#ef4444', fontSize: '22px' }} />,
            content: (
                <div style={{ marginTop: '10px', color: '#64748b', fontSize: '14px' }}>
                    Asegúrate de haber guardado tus ventas pendientes antes de salir.
                </div>
            ),
            okText: 'Cerrar Sesión',
            cancelText: 'Volver',
            okType: 'danger',
            centered: true,
            width: 420,
            okButtonProps: { style: { backgroundColor: '#ef4444', color: '#fff', border: 'none', height: '40px', borderRadius: '8px', fontWeight: '600' } },
            cancelButtonProps: { style: { height: '40px', borderRadius: '8px', fontWeight: '600', color: '#64748b' } },
            onOk() {
                logout();
                navigate('/login');
            },
        });
    };

    const items = [
        {
            key: '1',
            label: (
                <div style={{ padding: '8px 12px' }}>
                    <Text strong style={{ display: 'block' }}>{nombreUsuario} {apellidosUsuario}</Text>
                    <Text type="secondary" style={{ fontSize: '12px' }}>{correoUsuario}</Text>
                </div>
            ),
        },
        { type: 'divider' },
        { key: '2', icon: <UserOutlined />, label: <Link to="/ajustes?tab=perfil">Mi Perfil</Link> },
        { key: '3', danger: true, icon: <LogoutOutlined />, label: 'Cerrar Sesión', onClick: cerrarSesion },
    ];

    const extraMenuItems = [
        {
            key: 'fullscreen',
            icon: isFullscreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />,
            label: isFullscreen ? 'Salir de pantalla completa' : 'Ver a pantalla completa',
            onClick: toggleFullscreen,
        }
    ];

    return (
        <Layout style={{ height: '100vh', overflow: 'hidden', background: '#f0f2f5' }}>

            <Sider
                trigger={null}
                collapsible
                collapsed={collapsed}
                width={220}
                collapsedWidth={isMobile ? 0 : 65}
                breakpoint="md"
                style={{
                    position: isMobile ? 'absolute' : 'relative',
                    height: '100vh',
                    zIndex: 100
                }}
                theme="dark"
                className="yugonub-sidebar"
            >
                <div className="sidebar-logo" style={{ background: !collapsed ? '#fff' : 'none' }}>
                    <h1 style={{ color: '#22BABB', margin: 0, fontWeight: 900, fontSize: collapsed ? '22px' : '18px' }}>
                        {collapsed ? 'Y' : (
                            <img src="/img/g1.png" alt="Yugonub Logo" style={{ width: "140px", height: "25px" }} />
                        )}
                    </h1>
                </div>

                <nav className="sidebar-nav" style={{ opacity: (!configLoading && subStatus?.bloqueada) ? 0.3 : 1, pointerEvents: (!configLoading && subStatus?.bloqueada) ? 'none' : 'auto' }}>
                    <ul>
                        {hasPermission('ventas:ver') && <MenuNavItem to="/ventas" icon={IoStorefront} label="Ventas" title="Ventas" slug="ventas" current={pageSeleccionada} collapsed={collapsed} />}
                        {hasPermission('caja:ver') && <MenuNavItem to="/cierre-caja" icon={IoCash} label={collapsed ? "Caja" : "Cierre de Caja"} title="Cierre de Caja" slug="cierre-caja" current={pageSeleccionada} collapsed={collapsed} />}
                        {hasPermission('facturacion:ver') && <MenuNavItem to="/facturacion" icon={IoReceipt} label="Facturación" title="Documentos y Facturación" slug="facturacion" current={pageSeleccionada} collapsed={collapsed} />}
                        <MenuItemDivider />
                        {hasPermission('productos:ver') && <MenuNavItem to="/productos" icon={IoClipboard} label="Productos" title="Productos" slug="productos" current={pageSeleccionada} collapsed={collapsed} />}
                        {hasPermission('inventario:ver') && <MenuNavItem to="/inventario" icon={IoCube} label="Inventario" title="Entradas y Salidas" slug="inventario" current={pageSeleccionada} collapsed={collapsed} />}
                        {hasPermission('pedidos:ver') && <MenuNavItem to="/pedidos" icon={IoCart} label="Pedidos" title="Gestión de Pedidos" slug="pedidos" current={pageSeleccionada} collapsed={collapsed} />}
                        {hasPermission('ruta:ver') && <MenuNavItem to="/mi-ruta" icon={IoCar} label="Mi Ruta" title="Mi Ruta de Entregas" slug="mi-ruta" current={pageSeleccionada} collapsed={collapsed} />}
                        {hasPermission('compras:ver') && <MenuNavItem to="/compras" icon={IoCard} label="Compras" title="Compras" slug="compras" current={pageSeleccionada} collapsed={collapsed} />}
                        {hasPermission('proveedores:ver') && <MenuNavItem to="/proveedores" icon={IoPeopleCircle} label="Proveedores" title="Proveedores" slug="proveedores" current={pageSeleccionada} collapsed={collapsed} />}
                        <MenuItemDivider />
                        {hasPermission('informes:ver') && <MenuNavItem to="/informes" icon={IoAnalytics} label="Informes" title="Informes" slug="informes" current={pageSeleccionada} collapsed={collapsed} />}
                        {hasPermission('gastos:ver') && <MenuNavItem to="/gastos" icon={IoPricetag} label="Gastos" title="Gastos" slug="gastos" current={pageSeleccionada} collapsed={collapsed} />}
                        {hasPermission('clientes:ver') && <MenuNavItem to="/clientes" icon={IoPeople} label="Clientes" title="Clientes" slug="clientes" current={pageSeleccionada} collapsed={collapsed} />}
                        <MenuItemDivider />
                        {hasPermission('configuracion:ver') && <li style={{ pointerEvents: 'auto', opacity: 1 }}>
                            <Link to="/ajustes" title="Configuración" className={`nav-link ${pageSeleccionada === 'ajustes' ? 'active' : ''} ${collapsed ? 'is-collapsed' : 'is-expanded'}`}>
                                <IoSettings className="nav-icon" />
                                <span className="nav-text">{collapsed ? "Ajustes" : "Configuración"}</span>
                            </Link>
                        </li>}
                    </ul>
                </nav>
            </Sider>

            <Layout>
                <Header style={{ height: '50px', borderBottom: '2px solid #e2e8f0', background: colorBgContainer, padding: isMobile ? '0 10px' : '0 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', zIndex: 10 }}>

                    {/* ZONA IZQUIERDA */}
                    <div style={{ display: 'flex', alignItems: 'center', flex: isMobile ? 1 : 'none', minWidth: 0 }}>
                        <Button
                            type="text"
                            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                            onClick={() => setCollapsed(!collapsed)}
                            style={{ fontSize: '18px', width: 45, height: 45, marginRight: isMobile ? 5 : 10, flexShrink: 0 }}
                        />
                        {!isMobile && logoEmpresa && <Avatar src={logoEmpresa} shape="square" size="large" style={{ marginRight: '20px', marginLeft: '0px', border: '1px solid #e2e8f0', flexShrink: 0 }} />}

                        <h2 className="header-empresa-title" style={{ margin: 0, fontSize: isMobile ? '16px' : 'inherit', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {nombreEmpresa}
                        </h2>
                    </div>

                    {/* ZONA CENTRAL: Alerta de Suscripción */}
                    {!configLoading && subStatus?.porVencer && (
                        <div style={{ flex: 1, display: 'flex', justifyContent: 'center', padding: '0 5px' }}>
                            <div style={{ backgroundColor: '#fffbe6', border: '1px solid #ffe58f', padding: '4px 10px', borderRadius: '20px', display: 'flex', alignItems: 'center', gap: '5px' }}>
                                <ExclamationCircleOutlined style={{ color: '#faad14', fontSize: '14px' }} />
                                <Text type="warning" style={{ fontSize: '12px', margin: 0, fontWeight: '500' }}>
                                    {isMobile ? `Vence en ${subStatus.diasRestantes}d` : `Vence en ${subStatus.diasRestantes} ${subStatus.diasRestantes === 1 ? 'día' : 'días'}`}
                                </Text>
                            </div>
                        </div>
                    )}

                    {/* ZONA DERECHA: Opciones Extra y Perfil de Usuario */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? '8px' : '16px' }}>

                        {!isMobile && (
                            <Dropdown menu={{ items: extraMenuItems }} placement="bottomRight" trigger={['click']}>
                                <Button
                                    title='Ver a pantalla completa'
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: '8px',
                                        border: '1px solid #d9d9d9',
                                        height: '32px',
                                        width: '36px',
                                        background: '#F4F3F9'
                                    }}
                                >
                                    {isFullscreen ? <FullscreenExitOutlined style={{ fontSize: '20px', fontWeight: "800", fontFamily: "bold", color: '#1e293b' }} /> : <FullscreenOutlined style={{ fontSize: '20px', fontWeight: "800", fontFamily: "bold", color: '#1e293b' }} />}
                                </Button>
                            </Dropdown>
                        )}

                        {/* Perfil de Usuario */}
                        <Dropdown menu={{ items }} placement="bottomRight" arrow trigger={['click']}>
                            <Space style={{ cursor: 'pointer' }} className="user-dropdown-trigger">
                                {!isMobile && (
                                    <div style={{ textAlign: 'right', lineHeight: '1.2' }}>
                                        <Text strong style={{ display: 'block', color: '#001529' }}>{nombreUsuario} {apellidosUsuario}</Text>
                                        <Text type="secondary" style={{ fontSize: '11px' }}>{session?.rol?.nombre || 'Usuario'}</Text>
                                    </div>
                                )}
                                <Avatar style={{ backgroundColor: '#22BABB' }} src={session?.user?.avatar} icon={!session?.user?.avatar && <UserOutlined />} size="medium" />
                            </Space>
                        </Dropdown>
                    </div>

                </Header>

                <Content onClick={() => isMobile && !collapsed && setCollapsed(true)} style={{ height: 'calc(100vh - 52px)', overflow: 'auto', background: '#f8fafc', padding: isMobile ? '5px' : '10px 5px' }}>
                    {configLoading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <Spin size="large" tip="Verificando acceso..." />
                        </div>
                    ) : (
                        subStatus?.bloqueada && pageSeleccionada !== 'ajustes' ? (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80%', padding: '20px' }}>
                                <Result
                                    status="403"
                                    title="Servicio Suspendido"
                                    subTitle={
                                        hasPermission('configuracion:ver')
                                            ? "Tu cuenta ha sido bloqueada. Renueva para acceder a todas las funciones."
                                            : "El sistema de Yugonub se encuentra suspendido temporalmente. Por favor, comunícate con el administrador del negocio."
                                    }
                                    extra={
                                        hasPermission('configuracion:ver')
                                            ? <Button type="primary" size="large" onClick={() => navigate('/ajustes?tab=suscripcion')} style={{ backgroundColor: '#22BABB' }}>Ir a Renovar</Button>
                                            : <Button type="primary" danger size="large" icon={<LogoutOutlined />} onClick={cerrarSesion}>Cerrar Sesión</Button>
                                    }
                                />
                            </div>
                        ) : (
                            children
                        )
                    )}
                </Content>

            </Layout>
        </Layout>
    );
};

const MenuNavItem = ({ to, icon: Icon, label, title, slug, current, collapsed }) => {
    const isActive = current === slug;
    const estadoClase = collapsed ? 'is-collapsed' : 'is-expanded';
    return (
        <li>
            <Link to={to} title={title} className={`nav-link ${isActive ? 'active' : ''} ${estadoClase}`}>
                <Icon className="nav-icon" />
                <span className="nav-text">{label}</span>
            </Link>
        </li>
    );
};

const MenuItemDivider = () => <div className="nav-separator" />;

export default LayoutHome;